import { DotsThree, Info, UserPlus } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface ResellerMqttRowActionsProps {
	onAssign: () => void;
	onDetails: () => void;
}

export function ResellerMqttRowActions({
	onAssign,
	onDetails,
}: ResellerMqttRowActionsProps) {
	const { t } = useTranslation();
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" aria-label={t("common.actions")}>
					<DotsThree className="size-4" weight="bold" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				<DropdownMenuItem onClick={onDetails}>
					<Info className="size-4" />
					{t("mqttSources.details")}
				</DropdownMenuItem>
				<DropdownMenuItem onClick={onAssign}>
					<UserPlus className="size-4" />
					{t("mqttSources.assignToManager")}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
